import { z } from "zod";

export const flaggedScanActionSchema = z.enum(["Review", "AutoUpdate"]);

export const scanIngestionSettingsSchema = z.object({
	createNewProducts: z.boolean(),
	dimensionTolerance: z.number().nonnegative(),
	flaggedScanAction: flaggedScanActionSchema,
	isConfigured: z.boolean(),
});

export const updateScanIngestionSettingsSchema = scanIngestionSettingsSchema.omit({
	isConfigured: true,
});

export type ScanIngestionSettings = z.infer<typeof scanIngestionSettingsSchema>;
export type UpdateScanIngestionSettings = z.infer<typeof updateScanIngestionSettingsSchema>;
